// extracted by mini-css-extract-plugin
export var hidden = "_to-0";